class FileService {
    constructor($http, authenticationService, globalConstants) {
        // this.$http = $http;
        // this.authenticationService = authenticationService;
        // this.token = this.authenticationService.getToken();
        // this.globalConstants = globalConstants;
    }

    readFile() {
        return new Promise(function(resolve, reject) {
            var f = document.getElementById('file').files[0],
            r = new FileReader(),
            data = [];

            if(!f){
                resolve(data);
            }
        
            var mimetype = f.type;

            r.onloadend = function(e) {
                var image = btoa(new Uint8Array(e.target.result).reduce(function (data, byte){
                    return data + String.fromCharCode(byte);
                }, ''));

                data.image = image;
                data.mimetype = mimetype;
                data.fileextension = f.name.split('.').pop();

                resolve(data);
            }
            r.readAsArrayBuffer(f);
        });
    };

    getFileString(f) {
        return new Promise(function(resolve, reject) {
            console.log("in getfilestring");
            r = new FileReader(),
            data = "";

            if(!f){
                resolve(data);
            }

            console.log("in getfilestrin2");

            var mimetype = f.type;

            r.onloadend = function(e) {
                console.log("in getfilestring3");

                var image = btoa(new Uint8Array(e.target.result).reduce(function (data, byte){
                    return data + String.fromCharCode(byte);
                }, ''));
                data = mimetype + ";charset=utf-8;base64, "+ image;
                resolve(data);
            }
            r.readAsArrayBuffer(f);
        });
    };

}

export default FileService;


// WEBPACK FOOTER //
// ./src/js/services/file.service.js